import { type ReactNode } from "react";

import { Box, ListItemButton } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface HeaderMenuItemProps {
  id: string;
  onClick: () => void;
  label: ReactNode;
  isActive?: boolean;
  attentionCount?: number;
}

const HeaderMenuItem = (props: HeaderMenuItemProps) => {
  const { id, onClick, label, isActive, attentionCount } = props;

  return (
    <ListItemButton
      id={id}
      onClick={onClick}
      sx={{
        textDecoration: "none",
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
          borderBottom: isActive
            ? `2px solid ${theme.palette.semantic.primary.contrastText}`
            : "none"
        }
      }}
    >
      {label}
      {attentionCount && attentionCount > 0 && (
        <Box
          sx={{
            ml: 0.5,
            color: theme.palette.semantic.primary.contrastText,
            fontWeight: theme.typography.fontWeightMedium
          }}
        >
          ({attentionCount})
        </Box>
      )}
    </ListItemButton>
  );
};

export default HeaderMenuItem;
